import React, { useState, memo } from "react";
import { Button } from "@mui/material";
import moment from "moment-jalaali";
import ExcelJS from "exceljs";
import Api from "../../../utils/api";
import { Loading } from "../../../components";

const RewardParsianExcel = ({ object, period_id }) => {
    const [loading, setLoading] = useState(false);

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await new Api().get(`/period/${period_id}/export`, object);
            const items = response?.data || [];

            if (items.length === 0) {
                setLoading(false);
                return;
            }

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet("ParsianReward");

            worksheet.columns = [
                { header: "Destination Iban Number (Variz Be Sheba)", key: "iban", width: 40 },
                { header: "Owner Name (Name e Sahebe Seporde)", key: "full_name", width: 40 },
                { header: "Transfer Amount (Mablagh)", key: "amount", width: 25 },
                { header: "Description (Sharh)", key: "description", width: 25 },
            ];

            items.forEach((item) => {
                worksheet.addRow({
                    iban: item.shaba !== '-' ? 'IR' + item.shaba : '',
                    full_name: item.full_name || '',
                    amount: (item.total_pay * 10) || 0,
                    description: `پورسانت دوره ${period_id}`,
                });
            });

            worksheet.getRow(1).eachCell((cell) => {
                cell.font = { bold: true, size: 14 };
                cell.alignment = { horizontal: "center", vertical: "middle" };
                cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFCCEEFF" } };
                cell.border = {
                    top: { style: "thin" },
                    left: { style: "thin" },
                    bottom: { style: "thin" },
                    right: { style: "thin" }
                };
            });

            worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
                if (rowNumber > 1) {
                    row.eachCell((cell) => {
                        cell.font = { size: 12 };
                        cell.alignment = { horizontal: "center", vertical: "middle" };
                    });
                }
            });

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `parsian_${period_id}_${moment().unix()}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error exporting Parsian reward:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Button
                size="small"
                variant="outlined"
                color="default"
                onClick={fetchData}
                disabled={loading}
            >
                خروجی بانک پارسیان
            </Button>
            {loading && <Loading />}
        </>
    );
};

export default memo(RewardParsianExcel);